import {
  Checkbox,
  Grid,
  ListItemText,
  Menu,
  MenuItem
} from "@material-ui/core";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import { memo, useEffect, useState } from "react";
import { portOperationHeader } from "../../../constants";

import PortOperations from "../../../components/Calculator/PortOperations";

import AccountCargoDetails from "../../../components/Calculator/AccountCargoDetails";
import CalculatorVesselDetails from "../../../components/Calculator/CalculatorVesselDetails";
import CargoTabs from "../../../components/Calculator/CargoTabs";
import Expenses from "../../../components/Calculator/Expenses";
import MarginAndAllowances from "../../../components/Calculator/MarginAndAllowances";
import Result from "../../../components/Calculator/Result";


import clsx from "clsx";

function CalculatorMain(props) {
  const {
    disableEdit = false,
    selectedQuery = {},
    calculatorData = {},
    setCalculatorData = () => { },
    onChangeChartValue = () => { },
    selectedVessels = [],
    onChangeFleetRowSelect = () => { },
    onDeleteFleet = () => { },
    onClickAddFleet = () => { },
    addFleetModal = false,
    addFleetsArray = [],
    setAddFleetsArray = () => { },
    onChangeNewFleetsValue = () => { },
    setLoader = () => { },
    setAddFleetModal = () => { },
    sendCalculationRequest = () => { },
    setSelectedVessels = () => { },
    splitHireModal = false,
    setSplitHireModal = () => { },
    selectedSplitHire = {},
    setSelectedSplitHire = () => { },
    openSplitHireModal = () => { },
    onFetchPortOperationDistance = () => { },
    getInitalQueryAndFleetData = () => { },
    initialFleetList = [],

    onChangeSelectedVessel = () => { },
    fleetCheckbox = () => { },
    setFleetCheckbox = () => { },

    setMarginModal = () => { },
    syncBunker = () => { },
    setSyncBunker = () => { },
    setSupplyModal = () => { },
    onChangeSyncBunker = () => { },
    isOverride = () => { },
    cargoTabs = null,

    calculationErrors = {},

    marginModal,
    onChangePortOperations = () => { },
    onAddOperations = () => { },
    onDeleteOperations = () => { },
    supplyModal,
    fetchPortDistance = () => { },
    openAddOperation = () => { },
    setOpenAddOperation,
    setOpenAddOperationindex,
    onChangePortCanalInQueryState = () => { },
    setIsOverride,
    onReorder = null,
    onPortChange = null,
    hideOrder,
    hideCalculator,
    getCurrentResult,
    setShowExpensesModal = () => { },
    isFromCargoAnalysis = false,
    onChangeClientQuery = () => { },
    tcAdcom = 0,
  } = props;

  const { clientQuery = {} } = calculatorData || {};
  const showFreightSelection = clientQuery.freightMode === "Multiple Freight";

  let newPortOperationHeader = [...portOperationHeader];

  if (showFreightSelection) {
    newPortOperationHeader.splice(14, 0, {
      label: "Freight",
      width: 50,
    });
  }

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [columnAnchor, setColumnAnchor] = useState(null);

  useEffect(() => {
    if (!selectedColumns.length) {
      setSelectedColumns(newPortOperationHeader.map((col) => col.label));
    }
  }, [newPortOperationHeader]);

  const handleColumnMenuOpen = (event) => {
    setColumnAnchor(event.currentTarget);
  };

  const handleColumnMenuClose = () => {
    setColumnAnchor(null);
  };

  const toggleColumn = (label) => {
    setSelectedColumns((prev) => {
      if (prev.includes(label)) {
        return prev.filter((c) => c !== label);
      }
      return [...prev, label];
    });
  };

  return (
    <div className="calculator-section flex flex-col w-full min-w-0">
      <div className="flex flex-row w-full min-w-0">
        <div
          className={clsx("flex flex-col main-content-wrapper-inner min-w-0", {
            "w-full": hideOrder,
            "w-full": !hideOrder,
          })}
        >
          <div>
            <div className="calc-secound-section pt-0 min-w-0">
              <div className="flex flex-col gap-1 min-w-0">
                {hideCalculator.hideCalculator ? null : (
                  <Grid container spacing={1} className="calculator-summary-row">
                    <Grid item xs={12} sm={4} md={2}>
                      <div className="upper-section-grid min-h-full">
                        <AccountCargoDetails
                          calculatorData={calculatorData}
                          setLoader={setLoader}
                          getInitalQueryAndFleetData={getInitalQueryAndFleetData}
                          isFromCargoAnalysis={isFromCargoAnalysis}
                          IsEditable={true}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={8} md={4}>
                      <div className="upper-section-grid min-h-full">
                        <CalculatorVesselDetails
                          setLoader={setLoader}
                          setSelectedVessels={setSelectedVessels}
                          selectedVessels={selectedVessels}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          onChangeHandler={onChangeSelectedVessel}
                          fleetCheckbox={fleetCheckbox}
                          setFleetCheckbox={setFleetCheckbox}
                          isFromCargoAnalysis={isFromCargoAnalysis}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={4} md={2}>
                      <div className="upper-section-grid min-h-full">
                        <MarginAndAllowances
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          setSelectedVessels={setSelectedVessels}
                          setMarginModal={setMarginModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          syncBunker={syncBunker}
                          setSyncBunker={setSyncBunker}
                          setSupplyModal={setSupplyModal}
                          onChangeSyncBunker={onChangeSyncBunker}
                          isOverride={isOverride}
                          onChangeClientQuery={onChangeClientQuery}
                          tcAdcom={tcAdcom}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={4} md={2}>
                      <div className="upper-section-grid min-h-full">
                        <Expenses
                          onChangeSelectedVessel={onChangeSelectedVessel}
                          selectedVessels={selectedVessels}
                          openSplitHireModal={openSplitHireModal}
                          calculatorData={calculatorData}
                          setCalculatorData={setCalculatorData}
                          onChangeChartValue={onChangeChartValue}
                          setShowExpensesModal={setShowExpensesModal}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={4} md={2}>
                      <div className="upper-section-grid min-h-full">
                        <Result
                          selectedVessels={selectedVessels}
                          calculationErrors={calculationErrors}
                          getCurrentResult={getCurrentResult}
                          calculatorData={calculatorData}
                        />
                      </div>
                    </Grid>
                  </Grid>
                )}
                {/* port operations section drag and drop items */}
                <div className="relative z-0 overflow-hidden min-w-0 rounded-none bg-transparent py-0">
                  {!hideCalculator.hidePortList && calculatorData && (
                    <div className="middle-section-grid">
                      <div className="mb-0 flex justify-start items-center gap-1">
                        <button
                          type="button"
                          onClick={handleColumnMenuOpen}
                          aria-label="Select columns"
                          title="Select columns"
                          className="column-selection-btn h-[24px] w-[28px] p-0 flex items-center justify-center bg-[#313C4C] text-white hover:bg-[#1e2632] transition-colors rounded-[3px] outline-none border border-[#313C4C] cursor-pointer shadow-sm"
                          style={{ color: "#ffffff" }}
                        >
                          <ViewColumnIcon style={{ fontSize: 18, color: "#ffffff", fill: "#ffffff" }} />
                        </button>

                        <Menu
                          anchorEl={columnAnchor}
                          open={Boolean(columnAnchor)}
                          onClose={handleColumnMenuClose}
                          PaperProps={{ style: { maxHeight: 300 } }}
                        >
                          {newPortOperationHeader.map((col, i) => {
                            if (!col.label) return null;
                            return (
                              <MenuItem
                                key={i}
                                dense
                                onClick={() => toggleColumn(col.label)}
                                style={{ paddingTop: 0, paddingBottom: 0 }}
                              >
                                <Checkbox
                                  size="small"
                                  checked={selectedColumns.includes(col.label)}
                                  color="primary"
                                  style={{ padding: 4 }}
                                />
                                <ListItemText
                                  primary={col.label}
                                  primaryTypographyProps={{ variant: 'body2' }}
                                />
                              </MenuItem>
                            );
                          })}
                        </Menu>

                        {cargoTabs && (
                          <CargoTabs
                            list={cargoTabs.list}
                            selectedId={cargoTabs.selectedId}
                            onSelect={cargoTabs.onSelect}
                          />
                        )}
                      </div>
                      <PortOperations
                        disableEdit={disableEdit}
                        selectedColumns={selectedColumns}
                        marginModal={marginModal}
                        setMarginModal={setMarginModal}
                        sendCalculationRequest={sendCalculationRequest}
                        onChangePortOperations={onChangePortOperations}
                        calculatorData={calculatorData}
                        setCalculatorData={setCalculatorData}
                        syncBunker={syncBunker}
                        setSyncBunker={setSyncBunker}
                        onAddOperations={onAddOperations}
                        onDeleteOperations={onDeleteOperations}
                        selectedVessels={selectedVessels}
                        supplyModal={supplyModal}
                        setSupplyModal={setSupplyModal}
                        onChangeSyncBunker={onChangeSyncBunker}
                        onFetchPortOperationDistance={
                          onFetchPortOperationDistance
                        }
                        fetchPortDistance={fetchPortDistance}
                        openAddOperation={openAddOperation}
                        setOpenAddOperation={setOpenAddOperation}
                        setOpenAddOperationindex={setOpenAddOperationindex}
                        onChangeSelectedVessel={onChangeSelectedVessel}
                        isOverride={isOverride}
                        onChangePortCanalInQueryState={
                          onChangePortCanalInQueryState
                        }
                        setIsOverride={setIsOverride}
                        onReorder={onReorder}
                        onPortChange={onPortChange}
                      />
                    </div>
                  )}
                </div>

                {/* vessels selection section */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(CalculatorMain);
